<!-- 当前等级 -->
<template>
  <div
    class="blue-container level"
  >
    <RewardDescription
      :currentLevel="currentLevel"
      :rewardData="propsData"
    />
  </div>
</template>

<script>
import RewardDescription from '@/components/rewardDescription'
import { apiGet } from '@/services'

export default {
  name: 'level-page',
  components: {RewardDescription},
  data() {
    return {
      currentLevel: '',
      propsData: []
    }
  },
  mounted() {
    this.currentLevel = this.$route.query.currentLevel
    this.getReward()
  },
  methods: {
     // 获取奖励，微信授权
    getReward() {
      apiGet('partner/open/level/explain')
      .then(res => {
        if (res.code === '0000') {
          this.propsData = res.data
        } else {
          this.$handleErr(res.msg)
        }
      })
    }
  }

}
</script>

<style lang="less">
  .level{
    padding: 25px 16px 0;
  }
</style>
